var url = "49f797f1c2c7bf66cd51ac992e78a8ae.webp";
var cdnUrl = typeof _wml !== "undefined" && _wml.cdn && _wml.cdn.map(url);
module.exports = cdnUrl || __webpack_public_path__ + url;